module.exports = __webpack_public_path__ + "img/elementlengths_jasp.bd55f8cb.png";